import { NgForOf } from "@angular/common";
import { Directive, Host, Input, type NgIterable } from "@angular/core";

@Directive({
    // tslint:disable-next-line: directive-selector
    selector: '[ngForTrackByProperty]',
    standalone: false
})
export class NgForTrackByPropertyDirective<T> {

    @Input() ngForOf!: NgIterable<T>;
    @Input() ngForTrackByProperty!: keyof T;

    constructor(@Host() ngForOfDir: NgForOf<T>) {
        ngForOfDir.ngForTrackBy = (_, item: T): T[keyof T] => item[this.ngForTrackByProperty];
    }
}